import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from "../../environments/environment";
import { MobileAppService } from '../services/mobile-app.service';
import { LocaleService } from '../services/locale.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  pageSettings = {
    type: null
  }
  
  constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient,  private mobileAppService: MobileAppService, private localeService: LocaleService) {
  
    this.detectLocale();
    if (this.route.snapshot.paramMap.get('t') && this.route.snapshot.paramMap.get('interimPId')) {
      this.pageSettings.type = this.route.snapshot.paramMap.get('t');
  
      if(this.pageSettings.type === 's'){
         this.http.post(environment.baseUrl + 'payments/processInterimPayment', {_id: this.route.snapshot.paramMap.get('interimPId')} ).subscribe((data: any) => {
           if(data.success){

            if(data.data.isAirbnb){
              this.router.navigate(['/touristSuccess'])
              return true;
            }

            else{
              window.location.href = this.mobileAppService.getURL() + this.localeService.locale +  '/game;g='+data.data.checkoutObj.game+';p='+data.data.user.name
              return true;
            }

          /*   if(data.data.isMuseumPayment){
              window.location.href = data.data.url;
            } */
           
          } else{
            this.navigateBack();
          }
        
        })
      } else{
        setTimeout(()=>{
          this.router.navigate(['/']);
        },4000)
      }
    } else {
      this.navigateBack();
    }
  }

  detectLocale(){
    if(window.location.href.indexOf('/hu/') !== -1){
      this.localeService.locale = 'hu';
    } else if(window.location.href.indexOf('/de/') !== -1){
      this.localeService.locale = 'de';
    } else if(window.location.href.indexOf('/fr/') !== -1){
      this.localeService.locale = 'fr';
    } else if(window.location.href.indexOf('/es/') !== -1){
      this.localeService.locale = 'es';
    } else{
      this.localeService.locale = 'en';
    }
  }


  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  navigateBack() {
    this.router.navigate(['/']);
  }

  ngOnInit() {}
}
